import { render, staticRenderFns } from "./ErrorSnackbar.vue?vue&type=template&id=1ba31ce9&scoped=true"
import script from "./ErrorSnackbar.vue?vue&type=script&lang=js"
export * from "./ErrorSnackbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba31ce9",
  null
  
)

export default component.exports